<template>
	<lee-page code="supplyDemand" bg-img="/images/bg_head_5.jpg" title="供需" sub-title="News & Information" :search="true" height="280" @onSearch="onSearch" :bread="[{title:'供需',url:'/supplyDemand'},{title:typeInfo}]" v-if="typeInfo">
		<div class="bg-img-2" style="background-color:#f8f9fa">
			<div class="wrap1100 padding-top-50 padding-bottom-100">
				<div class="cl"></div>
				<div class="margin-bottom-50 margin-top-10">
					<el-row :gutter="20">
						<el-col :span="4">
							<div class="hand box-shadow-green text-center" style="border-radius: 6px;height: 40px;line-height: 40px;overflow: hidden;" :class="!searchForm.type_supply_id ? 'bg-green light' : 'green'" @click="changeType(null)">全部</div>
						</el-col>
						<el-col :span="20">
							<div class="flex" style="flex-wrap: wrap;gap: 20px;">
								<template v-for="(t,i) in typeList">
									<div class="hand box-shadow-green text-center" style="border-radius: 6px;height: 40px;line-height: 40px;overflow: hidden;padding-left:20px;padding-right: 20px;" :class="searchForm.type_supply_id === t.id ? 'bg-green light' : 'green'" @click="changeType(t)">{{t.name}}</div>
								</template>
							</div>
<!--							<el-row :gutter="20">-->
<!--								<el-col :span="6" v-for="(t,i) in typeList">-->
<!--									<div class="hand box-shadow-green text-center" style="border-radius: 6px;height: 40px;line-height: 40px;overflow: hidden;" :class="searchForm.type_supply_id === t.id ? 'bg-green light' : 'green'" @click="changeType(t)">{{t.name}}</div>-->
<!--								</el-col>-->
<!--							</el-row>-->
						</el-col>
					</el-row>
				</div>
				<div class="f16 dark-2" v-if="chooseType">{{chooseType.content}}</div>
				<template v-if="list.length > 0">
					<div class="text-center dark-3 padding-bottom-30">共查询到 <b class="red">{{ total }}</b> 条相关内容</div>
					<div class="box-shadow bg-light margin-bottom-20 hand rel" style="padding:10px;" v-for="(item,index) in list" @click="$router.push({path:'/supplyDemand/detail/'+item.id})">
						<div v-if="item.sort > 0" style="background-color: #F56C6C;color:#fff;top:0;right:10px;padding:0 10px;" class="abs f14">置顶</div>
						<div style="height: 120px;">
							<div class="hide">
								<div class="green-line">
									<img src="/images/icon/icon_30.png" height="22" class="z"/>
									<div v-html="item.title" class="f-b f20" style="padding-left:30px;line-height: 22px;"></div>
								</div>
								<div class="f14 dark-3 text-line-2" v-html="item.content"></div>
								<div class="f14 margin-top" style="color: #ccc">{{item.create_time}}</div>
							</div>
						</div>
					</div>
					<div class="text-center margin-top-100">
						<el-pagination
							:hide-on-single-page="true"
							background
							layout="pager"
							:page-size="pageSize"
							:current-page.sync="searchForm.page"
							:total="total"
							@current-change="pageChange">
						</el-pagination>
					</div>
				</template>
				<el-empty description="未查询到相关内容" v-else></el-empty>
			</div>
		</div>
	</lee-page>
</template>

<script>
export default {
	name: "Index",
	data() {
		return {
			list: [],
			pageSize: 10,
			total: 0,
			searchForm: {
				page: 1,
				title: '',
				title_type: '',
				type_supply_id:'',
				draft:'0',
				orderBy:'sort desc,create_time',
				sortBy:'desc',
				akey:''
			},
			typeInfo:null,
			typeList:[],
			chooseType:null
		}
	},
	created() {
		if (!this.$utils.isEmptyObject(this.$route.query)) {
			this.searchForm = {...this.searchForm,...this.$route.query};
		}

		if(this.$route.params.type){
			this.searchForm.akey = this.$route.params.type;
			this.getType()
		}

		this.searchForm.page = this.searchForm.page ? parseInt(this.searchForm.page) : 1;
	},
	mounted() {
		this.getList();
		this.$utils.addSystemTotal('module','supplyDemand','供需');
	},
	methods: {
		getList() {
			let _this = this;

			this.$http.post({
				url: '/Supply/listPage',
				data: {...this.searchForm, pageSize: this.pageSize},
				success(res) {
					_this.list = res.list;
					_this.total = res.totalCount;
				}
			})
		},
		getType() {
			if(this.searchForm.akey === 'supply'){
				this.typeInfo = '供应';
			}else{
				this.typeInfo = '需求';
			}
			this.getTypeList();
		},
		getTypeList(){
			let _this = this;

			this.$http.post({
				url: '/Type/listAll',
				data: {akey:this.searchForm.akey,state:1},
				success(res) {
					_this.typeList = res;
					if(_this.searchForm.type_supply_id) {
						for (let i = 0; i < _this.typeList.length; i++) {
							if (_this.searchForm.type_supply_id == _this.typeList[i].id) {
								_this.chooseType = _this.typeList[i];
							}
						}
					}
				}
			})
		},
		pageChange(page) {
			this.searchForm.page = page;

			this.$router.replace({query: {...this.searchForm}});
			// this.getList();
		},
		changeType(item){
			if(item) {
				this.chooseType = item;
				this.searchForm.type_supply_id = item.id;
			}else{
				this.chooseType = null;
				this.searchForm.type_supply_id = '';
			}
			this.searchForm.page = 1;
			this.$router.replace({query: {...this.searchForm}});
		},
		onSearch(k) {
			console.log(k);
			this.searchForm.title = k.title;
			this.searchForm.title_type = k.title_type;

			this.$router.replace({query: {...this.searchForm}});
		}
	}
}
</script>
